import React from "react";

const OptionGroup = ({ label, options, value, onChange }) => {
    return (
        <div className="mb-5">
            <h6 className="mb-3">{label}</h6>
            <div className="d-flex flex-wrap">
                {options.map((opt) => {
                    const selected = value === opt.value;

                    return (
                        <button
                            key={opt.value}
                            type="button"
                            className={`option-btn ${selected ? "is-selected" : ""}`}
                            onClick={() => onChange(opt.value)}
                            aria-pressed={selected}
                        >
                            {opt.label}
                        </button>
                    );
                })}
            </div>
        </div>
    );
};

export default OptionGroup;
